<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12.5rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
							option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData" :allowClear="true">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label style="margin-left:0.625rem ;">集中器</label>
			<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" option-filter-prop="children"  :filter-option="filterOption" 
							show-search  label-in-value   v-model="theGprs" @change="queryMeters" :allowClear="true">
				<a-select-option v-for="(item,index) in gprsList" :key="item.pId" :value="item.pId">{{item.gprsAddr}}</a-select-option>
			</a-select>
			<a-button size="small"   icon="search" type="primary" @click="queryMeters()" style="margin-left: 0.625rem;">查询</a-button>
			<a-button size="small"   icon="plus" type="primary" @click="showAddFlag = true" style="margin-left: 0.625rem;">新增电表</a-button>
		</div>
		<vxe-table  align="center" :data="elecMeterList"  border max-height="600"   ref="mTable" show-overflow="title" size="mini" stripe
						  resizable  :loading="loading">
				<vxe-table-column type="seq" width="45"></vxe-table-column>
				<vxe-table-column title="电表地址" field="meterAddr"></vxe-table-column>
				<vxe-table-column title="集中器地址" field="gprsId" :formatter="getTheGprs"></vxe-table-column>
				<vxe-table-column title="电压" field="voltage" sortable></vxe-table-column>
				<vxe-table-column title="电流" field="current"  sortable></vxe-table-column>
				<vxe-table-column title="总电量" field="totalQuantity" sortable></vxe-table-column>
				<vxe-table-column title="尖电量" field="spikeQuantity" sortable></vxe-table-column>
				<vxe-table-column title="峰电量" field="peakQuantity"  sortable></vxe-table-column>
				<vxe-table-column title="平电量" field="normalQuantity"  sortable></vxe-table-column>
				<!-- <vxe-table-column title="谷电量" field="valleyQuantity"  sortable></vxe-table-column> -->
				<vxe-table-column title="最后更新时间" field="updateTime"  :formatter="getTimeFormatter" width="160"></vxe-table-column>
				<vxe-table-column title="操作" field="id" width="240">
					<template #default="{ row }">
						<a-button size="small"  type="link" @click="createTask(row,7)" style="">电压</a-button>
						<a-button size="small"  type="link" @click="createTask(row,8)" style="margin-right: 0.625rem;">电流</a-button>
						<a-button size="small"  type="link" @click="createTask(row,1)" style="margin-right: 0.625rem;">电量</a-button>
						<a-dropdown>
						    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
								电量详情 <a-icon type="down" />
						    </a>
							<a-menu slot="overlay">
								<a-menu-item @click="createTask(row,6)">
									<a>总电量</a>
								</a-menu-item>
								<a-menu-item @click="createTask(row,2)">
									<a>尖电量</a>
								  </a-menu-item>
								<a-menu-item @click="createTask(row,3)">
									<a>峰电量</a>
								</a-menu-item>
								<a-menu-item @click="createTask(row,4)">
									<a>平电量</a>
								</a-menu-item>
							<!-- 	<a-menu-item @click="createTask(row,5)">
									<a>谷电量</a>
								</a-menu-item> -->
						    </a-menu>
						  </a-dropdown>
					</template>
				</vxe-table-column>
		</vxe-table>
		<a-drawer title="新增电表" :visible="showAddFlag"  width="480" @close="closeView" :destroyOnClose='true' :maskClosable="false">
			<ElecAddMeter :neighborList="neighborList" @closeView="closeView" @refreshList="queryMeters"/>
		</a-drawer>
	</div>
</template>

<script>
	import ElecAddMeter from '/src/components/ElecAddMeter.vue'
	export default {
		components:{
			ElecAddMeter,
		},
		data(){
			return {
				neighborList:[],
				theNeighbor:{},
				gprsList:[],
				theGprs:{},
				loading:false,
				elecMeterList:[],
				showAddFlag:false,
			}
		},
		methods:{
			createTask(row,type){
				let param = {
					type:type,
					gprsAddr:this.getTheGprsName(row.gprsId),
					meterAddr:row.meterAddr
				}
				let url = this.Api.getLastUrl(this.Api.ELEC_ADD_TASK_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.singleSubmiting = false;
					console.log(error);
				});
			},
			closeView(){
				this.showAddFlag = false;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getTheGprs({cellValue}){
				return this.getTheGprsName(cellValue);
			},
			getTheGprsName(gprsId){
				let result = null;
				for(var i=0;i<this.gprsList.length;i++){
					let item = this.gprsList[i];
					if(item.pId == gprsId){
						result = item.gprsAddr;
						break;
					}
				}
				return result;
			},
			queryData:function(){
				this.theGprs = {};
				this.queryGprs();
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryGprs:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_GPRS_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			queryMeters:function(){
				let url = this.Api.getLastUrl(this.Api.ELEC_QUERY_METER_LIST_URL);
				let param = {neighborId:this.theNeighbor.key,gprsId:this.theGprs.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.elecMeterList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
